import { lazy, Suspense, useMemo } from 'react'
import { GenericObjectCardProps } from '../GenericObjectCard'
import { GenericObjectCardContentWrapperProps } from '../GenericObjectCardContentWrapper'

export type UseGenericObjectCardWrapperProps = {
  wrapperType: GenericObjectCardProps['wrapperType']
  wrapperProps: GenericObjectCardContentWrapperProps['wrapperProps']
  components: GenericObjectCardContentWrapperProps['components']
  children: React.ReactNode
}

const LazyLoadComponent = lazy(() => import('site/Renderer/LoadComponent'))

const useGenericObjectCardWrapper = ({
  wrapperType,
  wrapperProps,
  children,
  components
}: UseGenericObjectCardWrapperProps) => {
  const componentWrapperProps = useMemo(() => {
    if (wrapperType === 'Accordion') {
      return {
        defaultOpenedIndexes: [0],
        heightClass: 'small',
        ...wrapperProps,
        items: [
          {
            uuid: '1',
            des: '',
            complement: '1'
          }
        ],
        renderAccordionDescription: () =>
          !!components && components?.length > 0 ? (
            <Suspense fallback={<></>}>
              <LazyLoadComponent components={components} />
            </Suspense>
          ) : null,
        renderAccordionTitle: () => children,
        allowInteractionOnlyOnIconClick: true
      }
    }
    return {}
  }, [wrapperType, wrapperProps, components, children])

  return {
    props: componentWrapperProps
  }
}

export default useGenericObjectCardWrapper
